import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchPosts } from '../actions'

class PostsDataLoader extends Component {
  componentDidMount() {
    if (this.props.shouldFetchPosts) {
      this.props.fetchPosts({ excludeBody: true })
    }
  }

  render() {
    return <>{this.props.children}</>
  }
}

PostsDataLoader.propTypes = {
  fetchPosts: PropTypes.func.isRequired,
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, { fetchPosts })(PostsDataLoader)
